import { FieldType } from 'database'
import { PDField, usePDFStore } from '../stores/pdf.store'
import { useMemo } from 'react'
import { nanoid } from 'nanoid'

export type CanvasBlockField =
  | {
      type: FieldType
      label: string
      defaultValue: () => Partial<PDField>
      disabled?: false
    }
  | {
      type: FieldType
      label: string
      defaultValue: () => Partial<PDField>
      disabled: true
      disabledReason: string
    }

export type CanvasBlock = CanvasBlockField

export const useBlocks = () => {
  const canvasBlocks = useMemo<
    {
      group: string
      fields: CanvasBlockField[]
    }[]
  >(() => {
    return [
      {
        group: 'Firma',
        fields: [
          {
            type: 'signature',
            label: 'Firma',
            defaultValue: () => ({
              is_required: true,
            }),
          },
          {
            type: 'initials',
            label: 'Iniciales',
            defaultValue: () => ({}),
          },
          {
            type: 'signature_date',
            label: 'Fecha de la firma',
            defaultValue: () => ({}),
          },
        ],
      },
      {
        group: 'Recurrentes',
        fields: [
          {
            type: 'email',
            label: 'Correo electrónico',
            defaultValue: () => ({}),
          },
          {
            type: 'company_name',
            label: 'Nombre de la empresa',
            defaultValue: () => ({}),
          },
          {
            type: 'person_name',
            label: 'Nombre de la persona',
            defaultValue: () => ({}),
          },
        ],
      },
      {
        group: 'Genéricos',
        fields: [
          {
            type: 'checkbox',
            label: 'Casilla de verificación',
            defaultValue() {
              return {}
            },
          },
          {
            type: 'text',
            label: 'Texto',
            defaultValue: () => ({}),
          },
          {
            type: 'textarea',
            label: 'Área de texto',
            defaultValue: () => ({}),
          },
          {
            type: 'number',
            label: 'Número',
            defaultValue: () => ({}),
          },
          {
            type: 'select',
            label: 'Selección',
            defaultValue: () => ({
              options: [
                {
                  id: nanoid(),
                  value: 'Opción 1',
                },
              ],
            }),
          },
        ],
      },
    ]
  }, [])

  return {
    canvasBlocks,
  }
}
